import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types.ts";
import { ContractStatus } from "../Contracts.types.ts";
import { ContractStandardField } from "../../entityTemplates/EntityTemplate.types.ts";
import { SelectableColoredItem } from "../../processingActivity/ProcessingActivity.types.ts";

export interface ContractOverviewViewModel {
    name: string;
    userFriendlyId: number;
    description: string | undefined;
    template: string;
    entityTemplateId: string;
    businessAreas: Array<SelectableColoredItem>;
    contractManager: string | undefined;
    startDate: Date | undefined;
    signatureDate: Date | undefined;
    endDate: Date | undefined;
    numberOfContractParties: number;
    legalEntities: Array<BaseViewModel>;
    counterparties: Array<BaseViewModel>;
    referenceNo: string | undefined;
    totalAmount: number | undefined;
    finalizedAmount: number | undefined;
    paymentTerms: string | undefined;
    specialTerms: string | undefined;
    note: string | undefined;
    contractExpiryNotificationInDays: number | undefined;
    contractStatus: ContractStatus;
    currencyCode: string | undefined;
    numberOfDocuments: number;
    numberOfContacts: number;
    numberOfObligations: number;
    numberOfRelatedContracts: number;
    numberOfTasks: number;
    isOverdue: boolean;
    hasObligationTemplates: boolean;
    templateSteps: Array<ContractTemplateStepInfo>;
    overviewTopFields: Array<ContractStandardField>;
    overviewBottomFields: Array<ContractStandardField>;
}

export interface ContractTemplateStepInfo {
    id: string;
    name: string;
    order: number;
}

export interface ContractOverviewCounterpartyViewModel {
    id: string;
    legalEntityId: string;
    name: string;
    address: string;
    zipCode: string;
    city: string;
    countryCode: string;
    types: Array<string>;
}

export interface ContractOverviewLegalEntityTableModel extends ContractOverviewCounterpartyViewModel {
    countryString: string;
    typesString: string;
}

export enum ContractOverviewTabEnum {
    Documents = 0,
    CounterParties = 1,
    Obligation = 2,
    Contacts = 3,
    Access = 4,
    RelatedContracts = 5,
    Tasks = 6,
}

export enum ContractOverviewPaperTabEnum {
    Main = 0,
    AllContractInfo = 1,
}

export enum ContractPlanTabId {
    Documents = "documents",
    CounterParties = "counterParties",
    Obligation = "obligation",
    Contacts = "contacts",
    Access = "access",
    RelatedContracts = "relatedContracts",
    Tasks = "tasks",
}
